'use client';

import React, { useState } from 'react';
import BaseModal from 'src/components/primitives/BaseModal/BaseModal';
import SignDependentColorValue from '../Utils/SignDependentColorValue';
import SkeletonValuePlaceholder from '../SkeletonValuePlaceholder/SkeletonValuePlaceholder';
import { toNotional } from 'src/utils/formatting';
import { PERFORMANCE_TIMEFRAMES } from 'src/@types/types';
import dynamic from 'next/dynamic';
import { PnLTimeSeriesDataPoint } from 'src/@types/performance';
import useModal from 'src/components/Modals/hooks/useModal';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import { PORTFOLIO_PERIOD_TAB_OPTIONS } from 'src/components/PortfolioPage/consts';
import { LoadingChart } from 'src/components/Charts/LoadingChart';
const PnlChart = dynamic(() => import('../PnlChart'));

const DEFAULT_INDEX = 2;

const UserCumFundingModal = () => {
	// const currentPerpMarkets = usePerpMarkets();
	// const marketOptions = useMemo(
	// 	() =>
	// 		[{ label: 'All', value: 'all' }].concat(
	// 			currentPerpMarkets
	// 				.filter((market) => !UIMarket.checkIsPredictionMarket(market))
	// 				.map((mkt) => {
	// 					return {
	// 						label: UIMarket.createPerpMarket(mkt.marketIndex).marketName,
	// 						value: mkt.marketIndex.toString(),
	// 					};
	// 				})
	// 		),
	// 	[currentPerpMarkets]
	// );
	const { hide } = useModal();
	// const currentAccountPubKey = useAccountData()?.pubKey;
	const displayDecimals = 2;
	const [chartData] = useState<PnLTimeSeriesDataPoint[]>();
	// const [currentMarketFilter, setCurrentMarketFilter] = useState<
	// 	number | 'all'
	// >('all');

	// const { data: marketPerformanceData = [] } = useFundingRateMarketPerformance({
	// 	currentAccountPubKey: currentAccountPubKey as PublicKey,
	// 	marketFilter: currentMarketFilter,
	// });

	const [selectedTimeFrame, setSelectedTimeFrame] = useState(
		PERFORMANCE_TIMEFRAMES[DEFAULT_INDEX]
	);

	// const handleMarketChange = useCallback((newMarket: string) => {
	// 	setCurrentMarketFilter(newMarket === 'all' ? 'all' : Number(newMarket));
	// }, []);

	// useEffect(() => {
	// 	const perfData = marketPerformanceData.find(
	// 		(mkt) => mkt.marketFilter === currentMarketFilter
	// 	);
	// 	setChartData(
	// 		perfData?.performance[
	// 			selectedTimeFrame as keyof typeof perfData.performance
	// 		]
	// 	);
	// }, [currentMarketFilter, marketPerformanceData, selectedTimeFrame]);

	// useEffect(() => {
	// 	const perfData = marketPerformanceData.find(
	// 		(mkt) => mkt.marketFilter === currentMarketFilter
	// 	)?.performance;

	// 	if (perfData) {
	// 		setChartData(perfData[selectedTimeFrame as keyof typeof perfData]);
	// 	}
	// }, [currentMarketFilter, marketPerformanceData]);

	const chartLabel = 'Funding Earned';

	return (
		<BaseModal.Container
			onClose={hide}
			dataTestId="user-cumulative-funding-modal"
		>
			<BaseModal.Title
				onClose={hide}
				closeButtonTestId="user-cumulative-funding-modal-close"
			>
				Historical Cumulative Funding
			</BaseModal.Title>

			<BaseModal.Body>
				<div className="w-full grow items-center justify-start px-4 pb-2">
					<span className="pl-2 text-2xl whitespace-nowrap">
						{chartData?.length ? (
							<SignDependentColorValue
								value={
									(chartData[chartData.length - 1]?.totalPnl ?? 0) -
									(chartData[0]?.totalPnl ?? 0)
								}
							>
								{toNotional(
									(chartData[chartData.length - 1]?.totalPnl ?? 0) -
										(chartData[0]?.totalPnl ?? 0),
									5
								)}
							</SignDependentColorValue>
						) : (
							<SkeletonValuePlaceholder className="h-6 w-12" loading={false} />
						)}
					</span>
				</div>

				<div className="max-h-[430px] min-h-[430px] w-full grow items-center justify-center px-4 pt-1 pb-4">
					{!chartData ? (
						<LoadingChart className="h-full" />
					) : (
						<PnlChart
							className="min-h-[430px]"
							id="user-funding-history"
							data={chartData}
							field={'totalPnl'}
							label={chartLabel}
							positive={false}
							decimalsToShow={displayDecimals}
							isHourly={selectedTimeFrame === '24h'}
							isInModal
						/>
					)}
				</div>

				<Tabs
					size="sm"
					variant="secondary"
					options={PORTFOLIO_PERIOD_TAB_OPTIONS}
					activeTab={selectedTimeFrame}
					onTabChange={setSelectedTimeFrame}
					className="w-fit"
				/>
			</BaseModal.Body>
		</BaseModal.Container>
	);
};

export default UserCumFundingModal;
